<template>
  <div class="t-balance" v-if="balance">
    <h2 v-if="!small">{{ balanceText.title }}</h2>
    <div class="t-balance__box">
      <p class="_big">{{ balance_format }}</p>
      <img src="/img/rub_big.png">
      <!--<p class="_small">≈ {{ ruble }}</p>-->
    </div>
    <!--<div class="t-balance__active" v-if="!small">-->
      <!--Доступно — {{ balance_format_active }} S <template v-if="balance.processing_balance !== ''">, в обработке на поступление — {{ balance.processing_balance }} S</template>-->
    <!--</div>-->
    <div class="t-balance__buttons" :class="{_absolute: small}">
      <button class="t-btn" @click.stop.prevent="modalDialogType_refillOpen"><span>{{ balanceText.add }}</span></button>
      <button class="t-btn t-btn_white" @click.prevent="modalDialogType_withdrawalOpen"><span>{{ balanceText.get }}</span></button>
      <button class="t-btn t-btn_white" @click.prevent="modalDialogType_promoOpen()" v-if="!small">
				<span>
					{{ balanceText.code }}
					<svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.08155 1.13274C6.42863 0.326777 7.57137 0.326779 7.91845 1.13274L8.92819 3.47746C9.07296 3.81363 9.38984 4.04385 9.7543 4.07765L12.2963 4.31342C13.17 4.39446 13.5232 5.48127 12.8639 6.06042L10.946 7.74529C10.671 7.98686 10.55 8.35937 10.6304 8.71644L11.1917 11.2069C11.3847 12.0629 10.4602 12.7346 9.70564 12.2866L7.51056 10.9832C7.19584 10.7963 6.80416 10.7963 6.48944 10.9832L4.29436 12.2866C3.53983 12.7346 2.61533 12.0629 2.80827 11.2069L3.36956 8.71644C3.45004 8.35937 3.329 7.98686 3.05402 7.74529L1.13609 6.06042C0.476825 5.48127 0.829953 4.39446 1.70372 4.31342L4.24571 4.07765C4.61016 4.04385 4.92704 3.81363 5.07181 3.47746L6.08155 1.13274Z" fill="#52A8F2"/>
					</svg>
				</span>
      </button>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        props: ['small'],
        computed: {
            ...mapGetters('staticText', ['balanceText']),
            ...mapGetters('profile', ['balance']),
            balance_format(){
                let a = this.balance.balance + '';
                a = a.split('.');
                a[0] = a[0].replace(/(\d{1,3})(?=((\d{3})*([^\d]|$)))/g, " $1");
                a = a.join('.');

                return a;
            },
            balance_format_active(){
                let a = this.balance.active_balance + '';
                a = a.split('.');
                a[0] = a[0].replace(/(\d{1,3})(?=((\d{3})*([^\d]|$)))/g, " $1");
                a = a.join('.');

                return a;
            },
            ruble(){
                let a = parseFloat(this.balance.balance) * parseFloat(this.balance.exchange_rates) + '';
                a = a.split('.');
                a[0] = a[0].replace(/(\d{1,3})(?=((\d{3})*([^\d]|$)))/g, " $1");
                if(a[1])
                    a[1] = a[1].substring(0,2);
                a = a.join('.');

                return a;
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogType_refillOpen', 'modalDialogType_withdrawalOpen', 'modalDialogType_promoOpen'])
        }
    }
</script>

<style lang="sass">
.t-balance
  position: relative
  h2
    color: $blue
    margin: 0 0 18px
    font-size: 22px
  &__box
    display: flex
    align-items: center
    justify-content: flex-start
    padding-bottom: 16px
    border-bottom: 1px solid $border
    img
      margin: 0 16px
    p
      font-weight: bold
    ._big
      color: $blue
      font-size: 36px
      line-height: 1.2
    ._small
      font-size: 22px
      line-height: 1.2
  &__active
    margin: 16px 0 24px
  &__buttons
    display: flex
    align-items: center
    justify-content: flex-start
    margin-top: 16px
    .t-btn:not(:last-child)
      margin-right: 8px
    &._absolute
      position: absolute
      top: 2px
      right: 0
      margin-top: 0

@media (max-width: 1260px)
  .t-balance
    &__buttons
      &._absolute
        position: relative
        top: 0
        margin-top: 24px

@media (max-width: 769px)
  .t-balance
    &__box
      padding-bottom: 0
      border-bottom: none
      margin-bottom: 16px
      flex-wrap: wrap
      p
        &._big
          font-size: 24px
        &._small
          width: 100%
          flex: none
          font-size: 20px
          margin-top: 6px
    &__buttons
      flex-direction: column
      .t-btn
        width: 100%
        &:not(:last-child)
          margin-right: 0
          margin-bottom: 8px
      &._absolute
        margin-top: 0
</style>



// WEBPACK FOOTER //
// src/vue_components/Balance.vue